import React, { Component } from 'react';
import UserForm from './UserForm';

export class UpdateUser extends Component {
    static displayName = UpdateUser.name;

    constructor(props) {
        super(props);
        this.state = {
            userId: this.props.match.params.userId
        };
    }

    render() {
        return (
            <UserForm userId={this.state.userId} formType='Update' />  
        );
    }
}